import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hcxolusnzeklivaqlbbk.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhjeG9sdXNuemVrbGl2YXFsYmJrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI1NTIxODgsImV4cCI6MjA4ODEyODE4OH0.EV-Zk_Mwbhmvj39JAfUaWRQzhwte2LU8YTn6I_7m-q8';

export const supabase = createClient(supabaseUrl, supabaseKey);